import {
  FETCH_USER_YEAR_LOADING,
  FETCH_USER_YEAR_ERROR,
  FETCH_USER_YEAR_SUCCESS,
  ACTIVATE_STAT_CARD,
  TOGGLE_MOBILE_NAV,
  TOGGLE_COMMUNITY_STATS,
} from './constants'

import createReducer from '../createReducer'

export const initialState = {
  'userYearLoading': false,
  'userYearError': false,
  'userYearData': null,
  'activeCards': [],
  'mobileNav': false,
  'showCommunityStats': false,
}

export default createReducer(initialState, {
  [FETCH_USER_YEAR_LOADING]: (state) => {
    return { ...state, userYearLoading: true }
  },

  [FETCH_USER_YEAR_ERROR]: (state) => {
    return { ...state, userYearLoading: false, userYearError: true }
  },

  [FETCH_USER_YEAR_SUCCESS]: (state, action) => {
    return {
      ...state,
      userYearLoading: false,
      userYearError: false,
      userYearData: action.payload.data,
    }
  },

  [ACTIVATE_STAT_CARD]: (state, action) => {
    return {
      ...state,
      activeCards: Array.from(new Set([...state.activeCards, action.payload])),
    }
  },

  [TOGGLE_MOBILE_NAV]: (state) => {
    return {
      ...state,
      mobileNav: !state.mobileNav,
    }
  },

  [TOGGLE_COMMUNITY_STATS]: (state) => {
    return {
      ...state,
      showCommunityStats: !state.showCommunityStats,
    }
  },
})



// WEBPACK FOOTER //
// ./src/services/yearInReview/reducer.js